import { NetworksRequestParams } from '../../api/nm-types'
import { FilterBy } from '../common/Filters/FilterView/FilterTemplate'

enum ListNetworkFilterKey {
  name = 'name',
}

export function mapNetworkFilterToUrlParam(filter: FilterBy): Partial<NetworksRequestParams> {
  if ('value' in filter) {
    switch (filter.key) {
      case ListNetworkFilterKey.name:
        return { filter: filter.value }
    }
  }
  return {}
}

export function mapUrlParamToNetworkFilter(key: keyof NetworksRequestParams, value: string): FilterBy | undefined {
  switch (key) {
    case 'filter':
      return {
        key: ListNetworkFilterKey.name,
        operator: 'matches',
        value,
      }
  }
  return undefined
}
